// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  listingId: __t.u64().primaryKey().name("listing_id"),
  versonaId: __t.u64().name("versona_id"),
  settlementId: __t.u64().name("settlement_id"),
  good: __t.string(),
  name: __t.string(),
  qty: __t.u32(),
  priceSov: __t.i64().name("price_sov"),
  active: __t.bool(),
  listedAt: __t.timestamp().name("listed_at"),
});
